import React from 'react';
import ScrollyHero from './ScrollyHero';

// HeroSection keeps the same prop shape as the other landing sections for
// caller consistency, but the scroll-driven hero is self-styled and does
// not consume `highlightColor`.
interface HeroSectionProps {
    highlightColor: {
        primary: string;
        hover: string;
        gradient: {
            from: string;
            to: string;
            fromLight: string;
            toGray: string;
        };
    };
}

const HeroSection: React.FC<HeroSectionProps> = (_props) => {
    return <ScrollyHero />;
};

export default HeroSection;
